module.exports = __webpack_public_path__ + "img/inter-medien.eacdf3d0.png";